
import { sceneScheduleSummaryAdapter, SceneScheduleSummaryState } from './scene-schedule-summary.entity';
import { EntityState } from '@ngrx/entity';
import { ScheduleSummary } from '../../../api/models/schedule-summary.model';
import { Action, on, createReducer } from '@ngrx/store';
import { sceneScheduleSummaryActionTypes } from './scene-schedule-summary.actions';
import { authActionTypes } from './../../../auth/store/auth.actions';

export const initialState: SceneScheduleSummaryState = sceneScheduleSummaryAdapter.getInitialState({
    ids: [],
    loaded: false,
    total: 0
});

export const sceneScheduleSummaryReducerObj = createReducer(
    initialState,

    on(sceneScheduleSummaryActionTypes.setSceneScheduleSummaryAction, (state, action) => {

        if (action.sceneScheduleSummaryList && action.sceneScheduleSummaryList !== null && action.sceneScheduleSummaryList.length > 0) {
            return sceneScheduleSummaryAdapter.addAll(action.sceneScheduleSummaryList, {
                ...state,
                loaded: action.sceneScheduleSummaryList.length > 0,
                total: action.sceneScheduleSummaryList.length
            })
        }
        else {
            return {
                ...state,
                loaded: false,
                total: 0
            }
        }

    }
    ),

    on(authActionTypes.LogOut, (state, action) => {
        // return accountAdapter.removeAll({ ...state, currentAccount:null })
        return sceneScheduleSummaryAdapter.removeAll({
            ...state,
            loaded: false,
            total: 0
        });
    }),

    on(sceneScheduleSummaryActionTypes.addSceneScheduleSummarySuccess, (state, action) => {
        if (state.entities[action.sceneScheduleSummary.Id])
            return state;
        else
            return sceneScheduleSummaryAdapter.addOne(action.sceneScheduleSummary, state)
    }

    ),

    on(sceneScheduleSummaryActionTypes.updateSceneScheduleSummarySuccess, (state, action) =>

        sceneScheduleSummaryAdapter.updateOne(action.update, state)
    ),

    on(sceneScheduleSummaryActionTypes.deleteSceneScheduleSummarySuccess, (state, action) =>

        sceneScheduleSummaryAdapter.removeOne(action.sceneId, state)
    ),

    on(sceneScheduleSummaryActionTypes.clear, (state, action) =>

        sceneScheduleSummaryAdapter.removeAll(state)
    ),


);

export function reducer(state: SceneScheduleSummaryState = initialState, action: Action): SceneScheduleSummaryState {
    return sceneScheduleSummaryReducerObj(state, action);
}

export const sceneScheduleSummarySelectors = sceneScheduleSummaryAdapter.getSelectors();
